import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { FN_GENERATION__status_lock } from '../_methods/FN_GENERATION__status_lock';
import { FN_GENERATION__status_unlock } from '../_methods/FN_GENERATION__status_unlock';
import { FN_GENERATION__update_locally } from '../_methods/FN_GENERATION__update_locally';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_stop = createAsyncThunkSafe<string, string>(
  ENUM__network_event_client_to_server.GENERATION_STOP,
  async (generation_id): Promise<string> => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_STOP, generation_id);

    return generation_id;
  },
);

export function INIT_REMOTE__generation_stop(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_stop.pending, (state, action) => {
      let generation_id = action.meta.arg;

      FN_GENERATION__status_lock(state, generation_id);

      let generation = state.generations_map.get_or_assert(generation_id, { context: 'generation' });
      generation.assert_statuses([ENUM__generation_status.IN_PROGRESS]);

      generation = generation.clone({ status: ENUM__generation_status.STOPPED });
      FN_GENERATION__update_locally(state, generation);
    })
    .addCase(REMOTE__generation_stop.rejected, (state, action) => {
      FN_GENERATION__status_unlock(state, action.meta.arg);
    })
    .addCase(REMOTE__generation_stop.fulfilled, (state, action: PayloadAction<string>) => {
      FN_GENERATION__status_unlock(state, action.payload);
    });
}
